export default __webpack_public_path__ + "images/DM.27b6cba.png";